var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkSparkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.38 8.19L21.86 0L26.34 8.19C28.46 12.07 31.65 15.26 35.53 17.38L43.72 21.86L35.53 26.34C31.65 28.46 28.46 31.65 26.34 35.53L21.86 43.72L17.38 35.53C15.26 31.65 12.07 28.46 8.19 26.34L0 21.86L8.19 17.38C12.07 15.26 15.26 12.07 17.38 8.19Z",
    fill: "#195F59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkSparkle);
export default __webpack_public_path__ + "static/media/DarkSparkle.527d3df35cada1d854f7c6a06b7f5fa6.svg";
export { ForwardRef as ReactComponent };